<template>
  <img src="../assets/StreetMetrics-MainLogo.png" width="300" height="45" alt="Streetmetrics logo">
</template>

<script>
export default {
  name: 'StreetmetricsLogo',
}
</script>
